import { atom } from 'jotai'
import type { FeatureFlag, FeatureFlagKey } from '@app/types'

export const featureFlagsAtom = atom<FeatureFlag[]>([])
export const featureFlagsLoadingAtom = atom(false)
export const featureFlagsErrorAtom = atom<Error | null>(null)

export const featureFlagMapAtom = atom<Record<FeatureFlagKey, boolean>>((get) => {
  const flags = get(featureFlagsAtom)
  const map = {} as Record<FeatureFlagKey, boolean>
  for (const f of flags) map[f.feature as FeatureFlagKey] = !!f.enabled
  return map
})

export const featureFlagEnabledAtom = (flagKey: FeatureFlagKey) =>
  atom((get) => get(featureFlagMapAtom)[flagKey] ?? false)

featureFlagsAtom.debugLabel = 'featureFlagsAtom'
featureFlagsLoadingAtom.debugLabel = 'featureFlagsLoadingAtom'
featureFlagsErrorAtom.debugLabel = 'featureFlagsErrorAtom'
featureFlagMapAtom.debugLabel = 'featureFlagMapAtom'
featureFlagEnabledAtom.debugLabel = 'featureFlagEnabledAtom'
